import { ReactElement, useCallback } from 'react';

import { MedicalDeviceOrderStatus } from '@dreryk/egabinet-ezwm-frontend-api';

import { Dropdown, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { medicalDevicesTranslationKeys } from '../../translations';

const DEVICE_ORDER_ERROR_STATUSES: MedicalDeviceOrderStatus[] = ['INCORRECT', 'REJECTED'];

type CorrectionDropdownItemProps = {
   readonly medicalDeviceOrderId: number;
   readonly visitId: number;
   readonly medicalDeviceOrderStatus: MedicalDeviceOrderStatus;
   readonly sameAsCurrentVisit: boolean;
};

export const CorrectionDropdownItem = (props: CorrectionDropdownItemProps): ReactElement | null => {
   const push = useHistoryPushWithBackAction(true);
   const goToOrderCorrection = useCallback(() => {
      const medicalDeviceOrderPath = visitPaths.getMedicalDeviceOrderPath({
         searchParams: {
            orderId: props.medicalDeviceOrderId,
         },
         params: {
            visitId: props.visitId,
         },
      });
      push(medicalDeviceOrderPath, {
         label: medicalDevicesTranslationKeys.goBackToVisit,
      });
   }, [props.visitId, props.medicalDeviceOrderId, push]);

   if (!DEVICE_ORDER_ERROR_STATUSES.includes(props.medicalDeviceOrderStatus)) {
      return null;
   }

   return (
      <Dropdown.Item
         testId={'correction'}
         onClick={(hide) => {
            goToOrderCorrection();
            hide();
         }}
         disabled={props.medicalDeviceOrderStatus !== 'REJECTED' || !props.sameAsCurrentVisit}
      >
         {medicalDevicesTranslationKeys.historicalMedicalDeviceOrder.orderCorrection}
      </Dropdown.Item>
   );
};
